import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=5b4df348&scoped=true&lang=pug&"
import script from "./loading.vue?vue&type=script&lang=coffee&"
export * from "./loading.vue?vue&type=script&lang=coffee&"
import style0 from "./loading.vue?vue&type=style&index=0&id=5b4df348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4df348",
  null
  
)

export default component.exports